import { render, staticRenderFns } from "./carrierHandle.vue?vue&type=template&id=024e54a6&scoped=true&"
import script from "./carrierHandle.vue?vue&type=script&lang=js&"
export * from "./carrierHandle.vue?vue&type=script&lang=js&"
import style0 from "./carrierHandle.vue?vue&type=style&index=0&id=024e54a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024e54a6",
  null
  
)

export default component.exports